import {Mixin, mix} from "mixwith";
import MutableMixin from "./MutableMixin.js";
import {arrayNotEqual} from "../../Utils/ArrayUtils.js";
import {deepCopy} from "../../Utils/ObjectUtils.js";

export const MutableArrayMixin = Mixin(superClass => class extends mix(superClass).with(MutableMixin) {

	static get properties() {
		return {
			items: {
				type: Array,
				attribute: false,
				hasChanged: arrayNotEqual
			}
		};
	}

	set items(value) {
		this.__items = value;
		this.requestUpdate("items", this.__oldItems);
	}

	get items() {
		return this.__items;
	}

	constructor() {
		super();
		this.items = [];
	}

	/**
	 * Sets the items to the defaultItems.
	 *
	 * @override
	 */
	resetChanges() {
		this.items = deepCopy(this.defaultItems);
	}

	/**
	 * Sets the current items as defaultItems.
	 *
	 * @override
	 */
	saveChanges(newItems = undefined) {
		if(newItems !== undefined)
			this.items = newItems;
		this.defaultItems = deepCopy(this.items);
		this.setInitialValue(this.defaultItems);
		this.updateChanges(this.defaultItems);
		// TODO: let the MutationAPI handle the changes when initial changes
		// TODO: Handle new items
	}

	firstUpdatedBeforeRender() {
		super.firstUpdatedBeforeRender();

		if(!this.hasInitialValue()) {
			// Sets the initial items as defaultItems which will be used when the element resets.
			if(this.defaultItems === undefined)
				this.defaultItems = deepCopy(this.items);

			// Sets the initial value.
			this.setInitialValue(this.defaultItems);
		}
	}

	update(changedProperties) {
		if(changedProperties.size === 0 || changedProperties.has("items")) {
			/**
			 * Holds a copy of previous Items, right after it was set.
			 * Cannot be fetched right before in the items setter, because the value
			 * is an array reference it can be changed without notice using array methods like
			 * push/splice/etc. and we could not get the "old" items.
			 *
			 * @type {[*]}
			 * @private
			 */
			this.__oldItems = deepCopy(this.items);

			// Update Mutation.
			{
				this.updateChanges(this.items);

				// Update binding
				const event = new CustomEvent("change", {
					composed: true,
					detail: {
						items: deepCopy(this.items)
					}
				});

				this.dispatchEvent(event);
			}
		}

		super.update(changedProperties);
	}

});

export default MutableArrayMixin;